export default function CTASection() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20shot%20of%20organized%20fashion%20products%20including%20sneakers%20leather%20bags%20denim%20jackets%20and%20sunglasses%20arranged%20in%20flowing%20horizontal%20composition%20on%20warm%20terracotta%20textured%20surface%2C%20golden%20hour%20backlight%20creating%20dramatic%20atmospheric%20glow%2C%20editorial%20lifestyle%20photography%2C%20rich%20earthy%20color%20palette%2C%20aspirational%20modern%20aesthetic&width=1800&height=1200&seq=cta-bg-v2-001&orientation=landscape"
        alt="Mulebuy Spreadsheet product sourcing guide"
        title="Start your Mulebuy Spreadsheet journey"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30"></div>

      <div className="relative w-full h-full px-8 md:px-14 flex flex-col justify-between py-14 md:py-20">
        <div className="max-w-xl">
          <h2 className="font-heading text-5xl md:text-7xl font-bold text-background-50 leading-[1.05] tracking-tight lowercase">
            mulebuy spreadsheet
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-6">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-950 text-sm font-medium cursor-pointer hover:bg-background-50 transition-all duration-200 whitespace-nowrap group"
          >
            <span>Explore Now</span>
            <span className="w-8 h-8 bg-foreground-950 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
              <i className="ri-arrow-right-line text-background-50 text-sm"></i>
            </span>
          </a>

          <div className="text-right max-w-sm">
            <p className="text-lg md:text-xl text-background-50/90 leading-relaxed font-light">
              Your complete resource for understanding cross-border shopping workflows and mastering the Mulebuy Spreadsheet system.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}